import { parse } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
import { INTERACTIVE_OBJECT_TYPE_ID } from '../constants/properties';
const getBaseUrl = () => window.location.pathname.includes('calls-to-action') ? '/calls-to-action' : '/web-interactives';
const READ_ONLY_PARAM_FLAG = 'testReadOnly';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getEditUrl = (contentId, showTour) => `${getBaseUrl()}/${PortalIdParser.get()}/edit/${contentId}/content${showTour ? '?showTour=true' : ''}`;
export const redirectToEditor = (contentId, showTour) => {
  const editUrl = new URL(`${window.location.origin}${getEditUrl(contentId, showTour)}`);
  const currentUrl = new URL(window.location.href);
  const insertFormGuid = currentUrl.searchParams.get('insertFormGuid');

  // Pass through form id as part of handoff process with new form editor
  if (insertFormGuid) {
    editUrl.searchParams.append('insertFormGuid', insertFormGuid);
  }
  window.location = editUrl.href;
};
export const getDetailsUrl = contentId => `/details/${contentId}`;
export const getCreateUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}/create`;

// When multiple values supplied for queryParam, use only the latest one
function getSingleValue(queryParams) {
  return Object.entries(queryParams).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value[value.length - 1];
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}
export function parseQueryParams(searchParams) {
  return getSingleValue(parse(searchParams.replace(/^(\?)/, '')));
}
export const getQueryParamsFromLocation = location => parseQueryParams(location.search);
export const getCtaPreviewUrl = (previewDomain, contentId) => `https://${previewDomain}/_hcms/preview/preview-interactive?previewInteractiveId=${contentId}&_preview=true&portalId=${PortalIdParser.get()}`;
export function hasReadOnlyUrl() {
  const queryParams = new URL(window.location.href).searchParams;
  return queryParams.get(READ_ONLY_PARAM_FLAG) === 'true';
}
export const getRecyclingBinUrl = (objectTypeId = INTERACTIVE_OBJECT_TYPE_ID) => {
  return `/recycling-bin/${PortalIdParser.get()}/restore/${objectTypeId}`;
};
export const getFromCampaignId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const fromCampaignId = queryParams.get('fromCampaignId');
  return fromCampaignId ? `fromCampaignId=${fromCampaignId}` : null;
};
export const getCreatedFromIlsListId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('createdFromIlsListId');
};